import React from 'react';
import {Platform, Text, TextInput, View} from 'react-native';
import {noop} from 'lodash';

const KeyboardExtendedInput =
  Platform.OS === 'web'
    ? TextInput
    : require('react-native-external-keyboard').KeyboardExtendedInput;

import {DownlineProfile} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import CreateSocialLinks from '../CreateSocialLinks/CreateSocialLinks';

import {styles} from './CandidateInputFields.style';
import {
  getHandleFocusHandler,
  getListItems,
  handleEmailChange,
  handleNameChange,
  handlePhoneNumberChange,
} from './CandidateInputFields.util';
interface CandidateInputFieldsProps {
  name: string;
  email: string;
  phoneNumber: string;
  setName: (value: string) => void;
  setEmail: (value: string) => void;
  setPhoneNumber: (value: string) => void;
  nameError: string;
  setNameError: (value: string) => void;
  emailError: string;
  setEmailError: (value: string) => void;
  phoneNumberError: string;
  setPhoneNumberError: (value: string) => void;
  socialLinksError: boolean;
  socialLinkText: Map<string, string>;
  setSocialLinksError: (value: boolean) => void;
  setSocialLinkText: (value: Map<string, string>) => void;
  urlDetailsData: any[];
  seturlDetailsData: (value: any[]) => void;
  popoverShow: () => void;
  isEditScreen: boolean;
  socialLinks: any[];
  setSocialLinks: (value: any[]) => void;
  isLink: boolean;
}

export const CandidateInputFields: React.FC<CandidateInputFieldsProps> = ({
  name = '',
  email = '',
  phoneNumber = '',
  setName = noop,
  setEmail = noop,
  setPhoneNumber = noop,
  nameError = '',
  setNameError = noop,
  emailError = '',
  setEmailError = noop,
  phoneNumberError = '',
  setPhoneNumberError = noop,
  socialLinksError = false,
  socialLinkText = new Map(),
  setSocialLinksError = noop,
  setSocialLinkText = noop,
  urlDetailsData = [],
  seturlDetailsData = noop,
  popoverShow = noop,
  isEditScreen = false,
  socialLinks = [],
  setSocialLinks = noop,
  isLink = true,
}) => {
  const fields = getListItems({
    handleNameChange,
    handleEmailChange,
    handlePhoneNumberChange,
    name,
    nameError,
    phoneNumber,
    phoneNumberError,
    email,
    emailError,
    setName,
    setNameError,
    setEmail,
    setPhoneNumber,
    setEmailError,
    setPhoneNumberError,
  });

  return (
    <View style={styles.container}>
      <View>
        <Text
          accessible={true}
          accessibilityRole="header"
          style={styles.header}
          {...testProperties(DownlineProfile.candidateProfileContactHeader)}
          accessibilityLabel="Contact Info">
          Contact Info
        </Text>
        {fields.map((field, index) => (
          <View key={index}>
            <Text
              style={styles.label}
              {...testProperties(field.id + '-label')}
              accessible={true}
              accessibilityLabel={`${field.label} label`}>
              {field.label}
            </Text>
            <View style={[styles.inputBox, field.error && styles.inputError]}>
              <KeyboardExtendedInput
                accessible={true}
                accessibilityLabel={`${field.label} required`}
                accessibilityHint={
                  field.value
                    ? undefined
                    : `Enter your ${field.label.toLowerCase()}`
                }
                style={styles.inputText}
                onChangeText={(text: string) => field.onChange(text)}
                onFocus={
                  isEditScreen
                    ? undefined
                    : () =>
                        getHandleFocusHandler({
                          setPhoneNumberError,
                          setEmailError,
                        })(field.id)
                }
                value={field.value}
                {...testProperties(field.id + '-input')}
              />
            </View>
            {field.error && (
              <Text
                style={styles.errorLabel}
                {...testProperties(field.id + '-error')}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={`Error:${field.errorMessage}`}>
                {field.errorMessage}
              </Text>
            )}
          </View>
        ))}
      </View>
      {isLink && (
        <View>
          <Text
            accessible={true}
            accessibilityRole="header"
            style={styles.header}
            {...testProperties(
              DownlineProfile.candidateProfileLinksHeader,
              false,
            )}
            accessibilityLabel="Links">
            Links
          </Text>
          <CreateSocialLinks
            setSocialLinkText={setSocialLinkText}
            socialLinkText={socialLinkText}
            socialLinksError={socialLinksError}
            setSocialLinksError={setSocialLinksError}
            urlDetailsData={urlDetailsData}
            seturlDetailsData={seturlDetailsData}
            popoverShow={popoverShow}
            socialLinks={socialLinks}
            setSocialLinks={setSocialLinks}
          />
        </View>
      )}
    </View>
  );
};
